type AppConfigKey =
  | "VITE_API_DOMAIN"
  | "VITE_WS_URL"
  | "VITE_FIREBASE_API_KEY"
  | "VITE_FIREBASE_AUTH_DOMAIN"
  | "VITE_FIREBASE_PROJECT_ID"
  | "VITE_FIREBASE_STORAGE_BUCKET"
  | "VITE_FIREBASE_SENDER_ID"
  | "VITE_FIREBASE_APP_ID"
  | "VITE_FIREBASE_VAPID_KEY"
  | "VITE_FIREBASE_MEASUREMENT_ID"
  | "VITE_SENTRY_DSN_FRONTEND"
  | "VITE_SENTRY_ENV"
  | "VITE_SENTRY_ENABLED"
  | "VITE_SENTRY_RELEASE"
  | "VITE_SENTRY_TRACES_SAMPLE_RATE"
  | "VITE_SENTRY_REPLAYS_SESSION_SAMPLE_RATE"
  | "VITE_SENTRY_REPLAYS_ERROR_SAMPLE_RATE";

type RuntimeAppConfig = Partial<Record<AppConfigKey, string>>;

function getRuntimeConfig(): RuntimeAppConfig {
  if (typeof window === "undefined") {
    return {};
  }
  return window.__APP_CONFIG__ || {};
}

export function getAppConfigValue(key: AppConfigKey): string {
  const runtimeValue = getRuntimeConfig()[key];
  if (typeof runtimeValue === "string" && runtimeValue.trim() !== "") {
    return runtimeValue.trim();
  }

  const buildValue = import.meta.env[key];
  if (typeof buildValue === "string") {
    return buildValue.trim();
  }

  return "";
}
